import React from "react";
import OtpInput from "react-otp-input";
import styled from "styled-components";

export default function AppOtpInput({ onChange, value }) {
  return (
    <OtpInput
      value={value}
      onChange={onChange}
      numInputs={6}
      inputStyle={{
        width: "60%",
        maxWidth: "70px",
        height: "60px",
        outline: "none",
        fontSize: "20px",
        appearance: "none",
        borderRadius: "4px",
        border: "none",
        background: "white",
      }}
      renderSeparator={<span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>}
      renderInput={(props) => <OtpStyle {...props} />}
    />
  );
}
const OtpStyle = styled.input`
  margin-bottom: 20px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
`;
